<template>
  <nx-bform-group
    :label="requiredLabel(name)"
    v-bind="$attrs"
    :description="description || `(${$t('telephone-sms')})`"
  >
    <nx-bform-input
      :name="name"
      :rules="{ required, numeric:true , min:8, max:15 }"
      :value="$attrs.value"
      @input="$listeners.input"
      :maxLength="15"
    />
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  props: ["description"],
  computed: {
    name() {
      return this.label || this.$t("telephone");
    }
  }
};
</script>

<i18n src="@/locales/registration.locale.json" />
